import React, {Component} from 'react'
import utils from '../../utils/utils'
import { Badge } from 'reactstrap';

export default class ServerItem extends Component {
  constructor(props, context) {
    super(props, context)
  }
  render(){
    let styles = ''
    let title = ''
    let icon = ''
    if (this.props.type === 'time') {
      styles = utils.getOnlineBadgetStyle(this.props.value)
      icon = utils.getArrowOnlineStyle(this.props.value)
    } else {
      styles = utils.getLoadStyles(this.props.value)
      title = `${this.props.value}%`
    }
    return(
        <Badge className={`ms-badge ${styles}`}>
          <h6>
            {icon}
            <span className='badget-text'>{`${this.props.title} ${title}`}</span>
          </h6>
        </Badge>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/server/InfoBadge.js